import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import GroupList from "./GroupList";
import NewMiniDrawer from "../../components/navMenu/menu-nav";

function GroupPage() {
  const db = firebase.firestore();

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // buscar grupos
  useEffect(() => {
    const unsubscribe = db
      .collection("tb_group")
      .orderBy("name")
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setGroups(data);
          setLoading(false);
        },
        (error) => {
          console.error("Erro ao buscar grupos:", error);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  // excluir grupo
  const handleDelete = async (group) => {
    const confirmar = window.confirm(
      `Tem certeza que deseja excluir o grupo "${group.name}"?`
    );

    if (!confirmar) return;

    try {
      await db.collection("tb_group").doc(group.id).delete();
      alert("Grupo excluído com sucesso!");
    } catch (error) {
      console.error(error);
      alert("Erro ao excluir o grupo.");
    }
  };

  return (
    <NewMiniDrawer
      divOpen={
        <>
          <GroupList
            groups={groups}
            loading={loading}
            openDeleteModal={handleDelete} //  chama direto
          />
        </>
      }
    />
  );
}

export default GroupPage;
